import api from "../../axiosConfig";

export const addMedicalHistoryData = async (formData,patientId) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post(`medical-histories/consult-medical-history-data/${patientId}`, formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success' || resData?.message_type === 'success') {
        return { success: true, data: resData };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getPremedicalHistoryData = async (patientId) => {

  try {
    const response = await api.get(`medical-histories/pre-medical-history-data/${patientId}`);

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success' || resData?.message_type === 'success') {
      
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching preconsult data');
  }
};

export const getmedicalHistorySectionData = async (searchKeyword,doctor_id,medical_history_category_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('medical-histories/all', {
      params: {
        doctor_id:doctor_id,
        search_keyword: searchKeyword,
        medical_history_category_id: medical_history_category_id,
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
  }
};

export const addMedicalHistoryItem = async (formData) => {
  const token = sessionStorage.getItem("token");
  try {
    const response = await api.post(
      `medical-histories/add`,
      formData
    );
    const resData = response?.data;
    console.log("Response data:", resData);

    if (
      resData?.success_type === "success" ||
      resData?.message_type === "success"
    ) {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || "Login error");
  }
};

export const updateMedicalHistoryItem = async (formData, medical_history_id) => {
  try {
    const response = await api.post(
      `medical-histories/update/${medical_history_id}`,
      formData
    );
    const resData = response?.data;
    console.log("Response data:", resData);

    if (
      resData?.success_type === "success" ||
      resData?.message_type === "success"
    ) {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || "Login error");
  }
};

export const getMedicalHistoryItems = async (searchKeyword, doctor_id,medical_history_category_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('medical-histories/all', {
      params: {
        doctor_id:doctor_id,
        search_keyword: searchKeyword,
        medical_history_category_id: medical_history_category_id,
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
  }
};